exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Students .question-types-block{display:flex;flex-direction:column}.Students .btn-actions{display:flex}.Students .table-data{margin-top:20px}.Students .table-data .actions{display:flex;align-items:center;flex-direction:row;color:#00adff}.Students .table-data .actions .far{margin-right:10px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/RoomsAndStudents/Students/style.scss
// module id = 4981
// module chunks = 0